// Module
var code = `<ng-form name="\$ctrl.form">
  <div class="form-column">
    <form-section form-title="'Organization'">
      <form-section-field field-title="'Name'">
        <input ng-model="\$ctrl.model.organizationConfig.name"
               required
               type="text"
               maxlength="64"
               title="Name"/>
      </form-section-field>

      <form-section-field field-title="'CIC provider'">
        <input ng-model="\$ctrl.model.organizationConfig.cicProviderCode"
               type="text"
               maxlength="8"
               title="CIC provider code"/>
      </form-section-field>

      <form-section-field field-title="'BSP code'">
        <input ng-model="\$ctrl.model.organizationConfig.bspCode"
               type="text"
               maxlength="7"
               title="BSP code"/>
      </form-section-field>

      <form-section-field field-title="'BSFI code'">
        <input ng-model="\$ctrl.model.organizationConfig.bsfiCode"
               ng-pattern="/^[a-zA-Z0-9]{10}\$/"
               type="text"
               maxlength="10"
               title="BSFI code"/>
      </form-section-field>

      <form-section-field fit-content="true" field-title="'DepEd code'">
        <input ng-model="\$ctrl.model.organizationConfig.depEdDeductionCode"
               type="text"
               ng-pattern="/^\\d{4}\$/"
               maxlength="4"
               minlength="4"
               title="DepEd code"/>
        <help title="DepEd code should be numeric with length 4"></help>
      </form-section-field>
      <form-section-field field-title="'Bank name'">
        <select ng-model="\$ctrl.model.organizationConfig.bankId"
                title="Bank name"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.BANK">
        </select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Accounting period'">
      <form-section-field field-title="'Close income and expense to Head Office?'">
        <select required
                name="closeToHeadOffice"
                boolean-options
                ng-model="\$ctrl.model.bookToHeadOffice">
        </select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Automated EOD'">
      <validator condition="!\$ctrl.model.automatedEodConfig.enabled || (\$ctrl.isNotificationTimeValid() && \$ctrl.isEodTimeValid())"></validator>

      <form-section-field field-title="'Enabled'">
        <select required
                boolean-options
                ng-model="\$ctrl.model.automatedEodConfig.enabled">
        </select>
      </form-section-field>

      <form-section-field field-title="'Perform at'"
                          ng-if="\$ctrl.model.automatedEodConfig.enabled">
        <input
          required
          type="time"
          ng-model="\$ctrl.model.automatedEodConfig.performAtTime"
          ng-class="{ 'nx-invalid': !\$ctrl.isEodTimeValid() }"/>
      </form-section-field>

      <form-section-field field-title="'Notification at'"
                          fit-content="true"
                          ng-if="\$ctrl.model.automatedEodConfig.enabled">
        <input
          required
          type="time"
          ng-model="\$ctrl.model.automatedEodConfig.notificationTime"
          ng-class="{ 'nx-invalid': !\$ctrl.isNotificationTimeValid() }"/>
        <help title="Notification can be shown between 5 minutes up to 1 hour before scheduled EOD"></help>
      </form-section-field>

      <form-section-field field-title="'Automatic start day'"
                          ng-if="\$ctrl.model.automatedEodConfig.enabled">
        <select required
                ng-options="o as o | prettyEnum for o in \$ctrl.startDayAndCloseCounterModeOptions"
                ng-model="\$ctrl.model.automatedEodConfig.startDayMode">
        </select>
      </form-section-field>
      <form-section-field field-title="'Automatic close counter'"
                          ng-if="\$ctrl.model.automatedEodConfig.enabled">
        <select required
                ng-options="o as o | prettyEnum for o in \$ctrl.startDayAndCloseCounterModeOptions"
                ng-model="\$ctrl.model.automatedEodConfig.closeCounterMode">
        </select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Automated Invoice'">
      <form-section-field field-title="'Enabled'">
        <select required
                boolean-options
                ng-model="\$ctrl.model.officialReceiptConfig.automationEnabled">
        </select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Collections'">
      <form-section-field field-title="'Collections invoice type'">
        <select required
          ng-options="receiptType as (\$ctrl.displayReceiptType(receiptType) | prettyEnum) for receiptType in \$ctrl.collectionReceiptTypes"
          ng-model="\$ctrl.model.collectionsConfig.receiptType">
        </select>
      </form-section-field>

      <form-section form-title="'Direct Transfer'">
        <form-section-field field-title="'Tags'">
          <input ng-model="\$ctrl.model.directTransferConfig.tags"
                 type="text"
                 maxlength="255"
                 title="DirectTransferTags"/>
          <help title="Comma separated values"></help>
        </form-section-field>
    </form-section>

    <form-section ng-if="\$ctrl.smsSupportEnabled" form-title="'Loan Payment SMS Notifications'">
      <form-section-field field-title="'Enable SMS notification for this channel'">
        <multiselect
          items="\$ctrl.smsNotificationChannelOptions"
          ng-model="\$ctrl.model.smsNotificationConfig.channels">
        </multiselect>
      </form-section-field>

      <form-section-field field-title="'SMS notification template'">
        <textarea
          rows="3"
          ng-model="\$ctrl.model.smsNotificationConfig.template"
          maxlength="256"
          required>
        </textarea>
      </form-section-field>

      <form-section-field field-title="'Template variables'" class="form-section-field--info">
        <table>
          <tr>
            <td><code ng-non-bindable>{{amount}}</code></td>
            <td>Payment amount</td>
          </tr>
          <tr>
            <td><code ng-non-bindable>{{date}}</code></td>
            <td>Payment date</td>
          </tr>
        </table>
      </form-section-field>

    </form-section>

    <form-section form-title="'PCHC Config'">
      <form-section-field field-title="'Direct clearing member'">
        <select required
                boolean-options
                ng-model="\$ctrl.model.pchcConfig.directClearingMember">
        </select>
      </form-section-field>

      <form-section-field
        field-title="'GL account'"
        ng-if="\$ctrl.model.pchcConfig.directClearingMember">
        <selectize
          required
          options="\$ctrl.ledgerAccounts"
          config="\$ctrl.ledgerAccountSelectConfig"
          ng-model="\$ctrl.model.pchcConfig.ledgerAccountCode">
        </selectize>
      </form-section-field>

    </form-section>

    <form-section form-title="'Branch Configuration'">
      <form-section-field field-title="'Require AMLA Institution Code'">
        <select required
                boolean-options
                ng-model="\$ctrl.model.amlaInstitutionCodeConfig.required">
        </select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Transaction History'">
      <form-section-field field-title="'Display Transaction Real Server Date Time for Deposit Account and Term Deposit'">
        <select required
                name="displayRealServerDateTime"
                boolean-options
                ng-model="\$ctrl.model.displayRealServerDateTime">
        </select>
      </form-section-field>
      <form-section-field field-title="'Enable Real Server Date Time Filter for Deposit Account and Term Deposit'">
        <select required
                name="enableRealServerDateTimeFilter"
                boolean-options
                  ng-model="\$ctrl.model.enableRealServerDateTimeFilter">
        </select>
      </form-section-field>
    </form-section>
  </div>

  <div class="form-column">
    <form-section form-title="'Before EOD email notification'">
      <email-notification-config ng-if="\$ctrl.model.beforeEodEmailConfig"
                                 config="\$ctrl.model.beforeEodEmailConfig"></email-notification-config>
    </form-section>

    <form-section form-title="'Start of EOD email notification'">
      <email-notification-config ng-if="\$ctrl.model.startEodEmailConfig"
                                 config="\$ctrl.model.startEodEmailConfig"></email-notification-config>
    </form-section>

    <form-section form-title="'Successful EOD email notification'">
      <email-notification-config ng-if="\$ctrl.model.successEodEmailConfig"
                                 config="\$ctrl.model.successEodEmailConfig"></email-notification-config>
    </form-section>

    <form-section form-title="'Failed EOD email notification'">
      <email-notification-config ng-if="\$ctrl.model.failedBranchEodEmailConfig"
                                 config="\$ctrl.model.failedBranchEodEmailConfig"></email-notification-config>
    </form-section>

    <form-section form-title="'Long-running EOD email notification'">
      <email-notification-config ng-if="\$ctrl.model.longRunningEodEmailConfig"
                                 config="\$ctrl.model.longRunningEodEmailConfig"></email-notification-config>
    </form-section>

    <form-section form-title="'Successful Oracle HOF email notification'">
      <email-notification-config ng-if="\$ctrl.model.successfulOracleHandoffEmailConfig"
                                 config="\$ctrl.model.successfulOracleHandoffEmailConfig"></email-notification-config>
    </form-section>

    <form-section form-title="'Health Check email notification'"
                  ng-if="\$ctrl.model.healthCheckJobEnabled">
      <email-notification-config ng-if="\$ctrl.model.healthCheckEmailConfig"
                                 config="\$ctrl.model.healthCheckEmailConfig"></email-notification-config>
    </form-section>
  </div>

</ng-form>

<div class="clearfix"></div>

<div class="summary-actions">
  <button
    type="button"
    class="btn btn-success"
    ng-disabled="\$ctrl.form.\$invalid"
    ng-click="\$ctrl.save()">
    Save changes
  </button>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/global-settings/global-settings.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;